import { render } from "./InlineColorInput.vue?vue&type=template&id=ebc3fe46&scoped=true"
import script from "./InlineColorInput.vue?vue&type=script&lang=js"
export * from "./InlineColorInput.vue?vue&type=script&lang=js"

import "./InlineColorInput.vue?vue&type=style&index=0&id=ebc3fe46&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc3fe46"]])

export default __exports__